import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/swap-form/i18n/de.ts
var de_default = {
  "widgets.swap-form.header.swap": "Tausch",
  "widgets.swap-form.input.title.you_pay": "Sie zahlen",
  "widgets.swap-form.input.title.you_receive": "Sie erhalten",
  "widgets.swap-form.input.balance.balance": "Kontostand",
  "widgets.swap-form.fusion-info.slippage-tolerance": "Toleranz f\xFCr Slippage",
  "widgets.swap-form.fusion-info.auction-time": "Auktionszeit",
  "widgets.swap-form.fusion-info.min-receive": "Mindestempfang",
  "widgets.swap-form.fusion-info.net-fee": "Netzwerkgeb\xFChr",
  "widgets.swap-form.swap-button.confirm-swap": "Tausch best\xE4tigen",
  "widgets.swap-form.swap-button.update-swap-data": "Tauschpfad wird gesucht",
  "widgets.swap-form.swap-button.check-allowance": "Zulage \xFCberpr\xFCfen",
  "widgets.swap-form.swap-button.native-token-not-supported": "Nativer Token wird derzeit nicht unterst\xFCtzt",
  "widgets.swap-form.swap-button.approve-and-swap": "Genehmigen und tauschen",
  "widgets.swap-form.swap-button.permit-and-swap": "Erlauben und tauschen",
  "widgets.swap-form.swap-button.connect-wallet": "Wallet verbinden",
  "widgets.swap-form.swap-button.select-source-token": "Quellen-Token ausw\xE4hlen",
  "widgets.swap-form.swap-button.select-destination-token": "Ziel-Token ausw\xE4hlen",
  "widgets.swap-form.swap-button.enter-amount-to-swap": "Betrag zum Tauschen eingeben",
  "widgets.swap-form.swap-button.no-liquidity-for-swap": "Keine Liquidit\xE4t f\xFCr den Tausch",
  "widgets.swap-form.swap-button.insufficient-balance": "Unzureichendes Guthaben von {{symbol}}",
  "widgets.swap-form.swap-button.set-max": "Maximalen {{symbol}} festlegen",
  "widgets.swap-form.swap-button.wait-wallet-response": "Auf Wallet-Antwort warten",
  "widgets.swap-form.swap-button.permit-swap-in-wallet": "Tausch im Wallet erlauben",
  "widgets.swap-form.swap-button.allow-swap-in-wallet": "Tausch im Wallet zulassen",
  "widgets.swap-form.swap-button.wallet-rejected": "Wallet hat die Anfrage abgelehnt",
  "widgets.swap-form.swap-button.swap-error-message": "Tauschfehler",
  "widgets.swap-form.swap-button.waiting-approve-transaction": "Warten auf Token-Genehmigung"
};
export {
  de_default as default
};
//# sourceMappingURL=de-JMXTJR4F.js.map
